import { currencyFormat } from "helpers/functions";
import ProductRow from "./ProductRow";
import { useTranslation } from "react-i18next";

import scss from "./CheckoutTable.module.scss";

const CheckoutTable = ({ items, cost, showImage = true, maxHeight = "300px", translateKey }) => {
    const { t } = useTranslation();

    return (
        <table className={scss.table}>
            <colgroup>
                <col span={1} style={{ width: "12.5%" }} />
                <col span={1} style={{ width: "15.5%" }} />
                <col span={1} style={{ width: "13.5%" }} />
                <col span={1} style={{ width: "9.5%" }} />
                <col span={1} style={{ width: "9.5%" }} />
                <col span={1} style={{ width: "12.5%" }} />
                <col span={1} style={{ width: "14.5%" }} />
                <col span={1} style={{ width: "12.5%" }} />
            </colgroup>
            <thead>
                <tr>
                    {showImage && <th className={scss.tcImage}>{t(`${translateKey}-image`)}</th>}
                    <th className={scss.tcCode}>{t(`${translateKey}-code`)}</th>
                    <th className={scss.tcTitle} width="*">
                        {t(`${translateKey}-title`)}
                    </th>
                    <th className={`${scss.rebate1} `}>{t(`${translateKey}-base_price`)}</th>
                    <th className={scss.rebate}>{t(`${translateKey}-rebate`)}</th>
                    <th className={scss.rebate}>{t(`${translateKey}-discount`)}</th>
                    <th className={scss.tcPrice}>{t(`${translateKey}-price_excluding_vat`)}</th>
                    <th className={scss.tcInt}>{t(`${translateKey}-quantity`)}</th>
                    <th className={scss.tcPrice2}>{t(`${translateKey}-total_excluding_vat`)}</th>
                    <th className={scss.tcActions} />
                </tr>
            </thead>
            <tbody style={{ maxHeight: maxHeight, borderColor: "transparent", borderStyle: "solid", borderWidth: "2px" }}>
                {items.map((item) => {
                    return <ProductRow translateKey={translateKey} max={+item?.product?.inventory?.amount} key={item?.product?.id + "_CheckoutTable"} item={item} showImage={showImage} />;
                })}

                {/* Show total cost */}
                {cost && (
                    <tr>
                        <td className={scss.tcTotalLabel} colSpan={6 + !!showImage}>
                            {t("global-default-text-Total")}:
                        </td>

                        <td className={scss.tcTotalPrice}>{currencyFormat(cost?.totals?.subtotal, cost?.currency)}</td>
                        <td className={scss.tcActions} />
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default CheckoutTable;
